import $ from 'jquery';
import Cache from 'next/javascripts/modules/cache';
import { DOMEval } from 'next/javascripts/modules/utils';

const requestCache = new Cache();

export default function request(opts = {}, callback) {
  const options = Object.assign({ cache: true, method: 'GET' }, opts);

  if (options.cache) {
    const cache = requestCache.get(options.url);
    if (cache) {
      if (cache.type === 'script') {
        DOMEval(cache.content);
      }

      if (typeof callback === 'function') {
        callback.call(null, { source: 'cache', ...cache });
      }
    }
  }

  return $.ajax(options).done((content) => {
    const cache = { type: options.dataType, content };
    if (options.cache) requestCache.set(options.url, cache);

    if (typeof callback === 'function') {
      callback.call(null, { source: 'remote', ...cache });
    }
  });
}

export function isCached(url) {
  return !!requestCache.get(url);
}

export function clearCache() {
  requestCache.clear();
}
